import { render, staticRenderFns } from "./IconSaveAsSolid.vue?vue&type=template&id=3f3f6d4a"
import script from "./IconSaveAsSolid.vue?vue&type=script&lang=js"
export * from "./IconSaveAsSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports